/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6130bd28050760571916bed45190e7bc34755b0c";
